import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../../../service/core.service';
import { ApiService } from '../../../../../service/api.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-reconcile',
  templateUrl: './reconcile.component.html',
  styleUrls: ['./reconcile.component.css']
})
export class ReconcileComponent implements OnInit {
  reconciliation: any;
  recnltn_id: any;
  entries: any;
  systemEntries: any;
  matchedEntries: any;
  bankEntries: any;
  reconcileBag: any[] = [];
  totalTransactionAmount: number = 0;
  selectedRows: boolean[] = [];
  selectedAmounts: number[] = [];
  selectedAmount: number = 0;
  selectedBankEntries: any[] = [];
  selectedMatches: { [key: string]: any } = {};
  cardData: any;
  systemBalance: any;
  excludedTransactions: any;
  isLoading: boolean;
  bankTransactions: any;
  systemTransactions: any;
  categorizedTransactions: any;
  filteredSystemEntries: any;
  applyFilter: boolean = false;
  debitEntry = '';
  creditEntry = '';
  uncategorizedSystemBalance: any;

  constructor(private apiService: ApiService, private coreService: CoreService, private ActiveRoute: ActivatedRoute) { }

  ngOnInit() {
    this.recnltn_id = this.ActiveRoute.snapshot.paramMap.get('id');
    this.getReconcileData();
    this.getReconcileBankEntries();
    //this.getReconcileSystemEntries();
    this.getCardData();
    this.getUncategorizedSystemBalance();
  }


  filter = {
    from: '',
    to: '',
    min: '',
    max: ''
  };

  
  toggleReconcile = (data: any) => {
    let amount = data.recnltn_sub_credit ? data.recnltn_sub_credit : data.recnltn_sub_debit;
    let isCredit = data.recnltn_sub_credit > 0,
      isDebit = data.recnltn_sub_debit > 0,
      hasCreditSelected = this.reconcileBag.some(item => item.recnltn_sub_credit > 0),
      hasDebitSelected = this.reconcileBag.some(item => item.recnltn_sub_debit > 0);



    if (isCredit && hasDebitSelected) {
      alert('You cannot select a credit entry while debit entries are selected.');
      return;
    }

    if (isDebit && hasCreditSelected) {
      alert('You cannot select a debit entry while credit entries are selected.');
      return;
    }
    
    if (this.reconcileBag.length > 0) {
      const selectedDate = this.reconcileBag[0].recnltn_sub_date;
      if (data.recnltn_sub_date !== selectedDate) {
        alert('You cannot select entries with different dates.');
        return;
      }
    }
   
    if (this.reconcileBag.includes(data)) {
      this.systemEntries = this.filteredSystemEntries = this.selectedRows = [];
      this.reconcileBag = this.reconcileBag.filter(item => item !== data);
      //this.totalTransactionAmount -= amount;
      this.totalTransactionAmount = parseFloat((this.totalTransactionAmount - amount).toFixed(2));
      if (isCredit && !this.reconcileBag.some(item => item.recnltn_sub_credit > 0)) {
        this.creditEntry = '';
      }
      if (isDebit && !this.reconcileBag.some(item => item.recnltn_sub_debit > 0)) {
        this.debitEntry = '';
      }

    } else {
      this.systemEntries = this.filteredSystemEntries = this.selectedRows = [];

      this.reconcileBag.push(data);
    //  this.totalTransactionAmount += amount;
    this.totalTransactionAmount = parseFloat((this.totalTransactionAmount + amount).toFixed(2));

      if (isCredit) {
        this.creditEntry = 'credit';
      }
      if (isDebit) {
        this.debitEntry = 'debit';
      }
      
    }
    this.selectedAmount = 0;
    this.getReconcileSystemEntries();
    this.updateBalance();
  }

  getCardData() {
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.getCardData(searchval).subscribe((res: any) => {
      this.cardData = res;

    });
  }

  getUncategorizedSystemBalance(){
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.getUncategorizedSystemBalance(searchval).subscribe((res: any) => {
      this.uncategorizedSystemBalance = res;

    });
  }


  onSelectChange(event: Event, index: number) {
    const target = event.target as HTMLSelectElement;
    const selectedValue = target.value;

    const entry = this.applyFilter ? this.filteredSystemEntries[index] : this.systemEntries[index];
    const rowAmount = entry.vch_in > 0 ? entry.vch_in : entry.vch_out; // Use vch_in if > 0, else vch_out
    const previousAmount = this.selectedAmounts[index] || 0;

    if (this.selectedRows[index]) {
      this.selectedAmount -= previousAmount;
    }

    if (selectedValue) {
      this.selectedAmount += rowAmount;
      this.selectedRows[index] = true;
      this.selectedAmounts[index] = rowAmount;
    } else {
      this.selectedRows[index] = false;
    }
    this.selectedAmounts[index] = rowAmount;
    this.updateBalance();
  }

  excludedTransaction() {
    let ids = this.reconcileBag.map(entry => entry.recnltn_sub_id),
      searchval = new FormData();
    searchval.append("reconcile_ids", JSON.stringify(ids));
    this.apiService.excludedTransaction(searchval).subscribe((res: any) => {
      this.reconciliation = res;
      this.coreService.showMessage(res.message);
      this.refreshReconcileState();
    });
  }

  viewExcludedTransactions() {
    this.isLoading = true;
    this.excludedTransactions = [];
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.excludedTransactionView(searchval).subscribe((res: any) => {
      this.excludedTransactions = res;
      this.isLoading = false;
    });
  }

  revertExcludedTransaction(recnltn_id) {
    if (confirm("Do you wish to revert this entry?")) {
      let searchval = new FormData();
      searchval.append('recnltn_id', recnltn_id);
      this.apiService.revertExcludedTransaction(searchval).subscribe((res) => {
        this.coreService.showMessage(res.message);
        this.viewExcludedTransactions();
        this.refreshReconcileState();
      });
    }
  }

  viewBankTransactions() {
    this.isLoading = true;
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.viewBankTransactions(searchval).subscribe((res: any) => {
      this.bankTransactions = res;
      this.isLoading = false;
    });
  }

  viewSystemTransactions() {
    this.isLoading = true;
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.viewSystemTransactions(searchval).subscribe((res: any) => {
      this.systemTransactions = res;
      this.isLoading = false;
    });
  }

  viewCategorizedTransactions() {
    this.isLoading = true;
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.viewCategorizedTransactions(searchval).subscribe((res: any) => {
      this.categorizedTransactions = res;
      this.isLoading = false;
    });
  }

  unlinkAllCategorized() {
    this.isLoading = true;
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.unlinkAllCategorized(searchval).subscribe((res: any) => {
      this.isLoading = false;
      this.coreService.showMessage(res.message);
      this.viewCategorizedTransactions();
      this.refreshReconcileState();
    });
  }

  unLinkCategorised(recnltn_sub_id) {
    this.isLoading = true;
    let searchval = new FormData();
    searchval.append("recnltn_sub_id", recnltn_sub_id);
    this.apiService.unLinkCategorised(searchval).subscribe((res: any) => {
      this.isLoading = false;
      this.coreService.showMessage(res.message);
      this.viewCategorizedTransactions();
      this.refreshReconcileState();
    });
  }

  private refreshReconcileState(): void {
    this.debitEntry = '';
    this.creditEntry = '';
    this.getReconcileData();
    this.getReconcileBankEntries();
    this.getReconcileSystemEntries();
    this.getCardData();
    this.getUncategorizedSystemBalance();
    this.totalTransactionAmount = 0;
    this.selectedAmount = 0;
    this.selectedRows = [];
    this.selectedMatches = {};
    this.reconcileBag = [];
   
  }


  updateBalance() {
    const balanceAmount = parseFloat((this.totalTransactionAmount - this.selectedAmount).toFixed(2));
    const balanceElement = document.getElementById("balanceAmount");
    //if (this.selectedAmount > 0) {
      if (balanceElement) {
        const formattedBalance = balanceAmount.toFixed(2); 
        balanceElement.textContent = this.selectedAmount > 0 ? formattedBalance : '0.00';
      }
  //  }
  }

  getStyle(data: any) {
    return this.reconcileBag.includes(data)
      ? { backgroundColor: 'lightblue', color: 'white', borderColor: 'lightblue' }
      : {};
  }

 
  getReconcileData() {
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.getReconcileData(searchval).subscribe((res: any) => {
      this.reconciliation = res;
    });
  }

  getReconcileBankEntries() {
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    this.apiService.getReconcileBankEntries(searchval).subscribe((res: any) => {
      this.bankEntries = res;
    });
  }

  getReconcileSystemEntries() {
    let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    searchval.append("credit_entry", this.creditEntry);
    searchval.append("debit_entry", this.debitEntry);
    this.apiService.getReconcileSystemEntries(searchval).subscribe((res: any) => {
      this.systemEntries = res;
      if(this.systemEntries){
        this.systemBalance = this.systemEntries.reduce((sum, entry) => {
          return sum + ((entry.vch_in || 0) - (entry.vch_out || 0));
        }, 0);
      }
    });
  }


  applyFilterSubmit() {
  let searchval = new FormData();
    searchval.append("recnltn_id", this.recnltn_id);
    searchval.append("filter_from_date", this.apiService.formatDate(this.filter.from));
    searchval.append("filter_to_date", this.apiService.formatDate(this.filter.to));
    searchval.append("filter_min", this.filter.min);
    searchval.append("filter_max", this.filter.max);
    searchval.append("credit_entry", this.creditEntry);
    searchval.append("debit_entry", this.debitEntry);
    this.applyFilter = true;
    this.apiService.applyFilterSubmit(searchval).subscribe((res: any) => {
      this.filteredSystemEntries = res; 

      if (res.error) 
        this.coreService.showMessage(res.error);

    });
  }

  matchEntries(): void {
    const matchedEntries = Object.entries(this.selectedMatches);
    const formData = new FormData();

    let totalSystemAmount = 0,
      totalBankAmount = 0;

    const seenBankEntryIds = new Set<number>();
    matchedEntries.forEach(([vchId, bankEntry], index) => {
      if (!bankEntry || bankEntry.id === undefined || bankEntry.id === null) {
        return; 
      }
    
      const systemEntry = this.systemEntries.find((entry: any) => entry.vch_id == vchId);
      const systemAmount = systemEntry.vch_in > 0 ? systemEntry.vch_in : systemEntry.vch_out;
      const bankAmount = bankEntry.amount;

      totalSystemAmount += systemAmount;

      if (!seenBankEntryIds.has(bankEntry.id)) {
        totalBankAmount += bankAmount;
        seenBankEntryIds.add(bankEntry.id);
      }

      formData.append(`matchedEntries[${index}][systemVchId]`, vchId);
      formData.append(`matchedEntries[${index}][bankEntryId]`, bankEntry.id);

    });
    formData.append("recnltn_id", this.recnltn_id);
    formData.append("totalSystemAmount", totalSystemAmount.toString());
    formData.append("totalBankAmount", totalBankAmount.toString());
    formData.append("selectedBankEntries", JSON.stringify(Object.values(this.selectedMatches)));
    formData.append("credit_entry", this.creditEntry);
    formData.append("debit_entry", this.debitEntry);

    this.apiService.reconciliationMatching(formData).subscribe((res: any) => {
      this.matchedEntries = res;
    
      if (res.message) {
        this.coreService.showMessage(res.message);
        this.systemEntries = this.filteredSystemEntries = [];
        this.refreshReconcileState();
        if (this.applyFilter) {
          this.applyFilterSubmit();
        }
       } else
        this.coreService.showMessage(res.error);
    });
  }



}
